import React from "react";
import PageLayout from "components/layouts/PageLayout";

export default function UnavailablePage(props) {
  return (
    <PageLayout hideNav centerLogo supportMode {...props}>
      <h1>Page Unavailable</h1>
      <div className="hr hr--darkest" />
      <p>
        The page you requested is unavailable. Please check your link and try
        again.
      </p>
    </PageLayout>
  );
}
